module.exports = __webpack_public_path__ + "static/media/icn-square.25b7d7b9.svg";